import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';

@Component({
	selector: 'paypal-tab',
	templateUrl: './paypal-tab.component.html',
	styleUrls: ['./paypal-tab.component.scss']
})
export class PaypalTabComponent implements OnInit {
	@Output() public updateUserDetails = new EventEmitter();
	@Output() public goToPlan = new EventEmitter();
	submitted: boolean = false;
	userDetails: any = null;
	labelStatus: string = 'default_show';
	merchantForm: FormGroup;
	
	constructor(
		private fb: FormBuilder,
		private loaderService: LoaderService,
		private userService: UserService,
		private sharedDataService: SharedDataService
	) { }

	ngOnInit(): void {
		this.merchantForm = this.fb.group({
			paypal_client_id: [this.userDetails ? this.userDetails?.payment_model?.paypal_client_id : '', Validators.required],
			paypal_secret_key: [this.userDetails ? this.userDetails?.payment_model?.paypal_secret_key : '', Validators.required],
		});
	}

	@Input('userDetails')
	set setUserDetails(val: any) {
		// console.log(val , this.merchantForm);
		if (val) {
			this.userDetails = val;
			if (this.merchantForm) {
				this.merchantForm.get('paypal_client_id').setValue(val?.payment_model?.paypal_client_id);
				this.merchantForm.get('paypal_secret_key').setValue(val?.payment_model?.paypal_secret_key);
			}
		} else {
			if (this.merchantForm) {
				this.merchantForm.get('paypal_client_id').setValue('');
				this.merchantForm.get('paypal_secret_key').setValue('');
			}
		}

		if (this.userDetails?.subscription.subscription_status == 'free') {
			this.labelStatus = 'free_user';
		} else {
			this.labelStatus = 'paid_user';
		}
	}

	get f() {
		return this.merchantForm.controls;
	}

	onSubmit(form: FormGroup) {
		this.submitted = true;
		if (form.valid) {
			this.loaderService.startLoading();
			this.userService.addMerchantInfo('paypal', form.value).subscribe(
				(res: any) => {
					this.loaderService.stopLoading();

					// Update parent user
					this.userDetails = res.user;
					this.updateUserDetails.emit(this.userDetails);

					// Update app basic info for user
					let userInfo = this.sharedDataService.getItem('userInfo');
					if (userInfo != undefined) {
						userInfo = this.userDetails;
						this.sharedDataService.setItem('userInfo', userInfo);
					}

					Swal.fire(i18n.done, 'Thank you for entering your details', 'success');
				},
				(err) => {
					this.loaderService.stopLoading();
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
							let validationErrors = err.error.errors;
							Object.keys(validationErrors).forEach((prop) => {
								this.merchantForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					}
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				}
			)
		}
	}

	deleteMerchant() {
		this.submitted = false;
		Swal.fire({
			title: i18n.are_you_sure,
			text: i18n.setting.remove_paypal_merchant_confirm,
			icon: 'info',
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: i18n.yes,
			cancelButtonText: i18n.no_cancel_it
		}).then((result: any) => {
			if (result.value) {
				this.loaderService.startLoading();
				this.userService.removeMerchant('paypal').subscribe((data: any) => {
					this.loaderService.stopLoading();
					this.merchantForm.get('paypal_client_id').setValue('');
					this.merchantForm.get('paypal_secret_key').setValue('');

					// Update parent user
					this.userDetails.payment_model.paypal_client_id = null;
					this.userDetails.payment_model.paypal_secret_key = null;
					this.userDetails.accept_paypal_payment = 0;
					this.updateUserDetails.emit(this.userDetails);

					// Update app basic info for user
					let userInfo = this.sharedDataService.getItem('userInfo');
					if (userInfo != undefined) {
						userInfo.payment_model.paypal_client_id = null;
						userInfo.payment_model.paypal_secret_key = null;
						userInfo.accept_paypal_payment = 0;
						this.sharedDataService.setItem('userInfo', userInfo);
					}

					setTimeout(function () {
						Swal.fire(i18n.done, i18n.setting.remove_paypal_merchant_success, 'success');
					}, 0);
				}, err => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				})
			} else {
				return false;
			}
		});
	}

}
